export default __webpack_public_path__ + "assets/images/others/e0d64242fb186fd72c9738396aab71a5.png";